import { Loader2 } from 'lucide-react';

/**
 * Registration entry, drawn as a British numberplate (handoff: #FFD900 ground, 2.5px
 * black edge, mono 600, +8% tracking, centred) with the Look up button beside it at the
 * same height. It is the only field required to create a job, so it is the largest
 * control on the page. Return looks the plate up rather than submitting the form.
 */
export function RegPlate({
  value,
  onChange,
  onSearch,
  searching = false,
  placeholder = 'AB12 CDE',
  autoFocus = false,
}: {
  value: string;
  onChange: (value: string) => void;
  onSearch?: () => void;
  searching?: boolean;
  placeholder?: string;
  autoFocus?: boolean;
}) {
  return (
    <div className="flex items-stretch gap-2.5">
      <input
        value={value}
        onChange={(e) => onChange(e.target.value.toUpperCase())}
        onKeyDown={(e) => {
          if (e.key === 'Enter' && onSearch) {
            e.preventDefault();
            onSearch();
          }
        }}
        placeholder={placeholder}
        aria-label="Registration"
        autoFocus={autoFocus}
        autoComplete="off"
        autoCapitalize="characters"
        spellCheck={false}
        className="reg-plate h-16 min-w-0 flex-1 px-4 text-[30px] sm:max-w-[340px]"
      />
      {onSearch && (
        <button
          type="button"
          onClick={onSearch}
          disabled={searching}
          className="flex h-16 w-[104px] shrink-0 items-center justify-center rounded-[10px] bg-accent text-[16px] font-semibold text-onaccent transition duration-[180ms] ease-out hover:brightness-[1.07] focus:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-2 focus-visible:ring-offset-elev disabled:cursor-wait"
        >
          {searching ? <Loader2 size={20} className="animate-spin" aria-label="Looking up" /> : 'Look up'}
        </button>
      )}
    </div>
  );
}
